<ns-grid
  [name]="configs.gridName"
  [gridTitle]="configs.gridTitle"
  [rowSelection]="configs.rowSelection"
  [config]="configs.headerOptions"
  [data]="data"
  [columns]="configs.columns"
  [loading]="loading"
  [gridOptions]="configs.options"
  [invalidEquipments]="invalidEquipments"
  (refresh)="handleRefresh()"
  (sortChanged)="emitSort()"
  (ready)="emitGridReady($event)"
  (rowDataUpdated)="emitRowDataUpdated()">
</ns-grid>
